import DOMPurify from 'dompurify'

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.nodeName === 'A') {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

const BIO_TAGS = ['b','strong','i','em','u','a','blockquote','ul','ol','li','p','br','div','span']
const STORY_TAGS = [...BIO_TAGS,'h1','h2','h3','h4','h5','h6','hr','sub','sup','s','del']
const URL_REGEXP = /^https?:\/\//i

export function sanitizeBio(html) {
  if (!html) return ''
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: BIO_TAGS,
    ALLOWED_ATTR: ['href', 'target', 'rel'],
    ALLOWED_URI_REGEXP: URL_REGEXP,
  })
}

export function sanitizeStoryContent(html) {
  if (!html) return ''
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: STORY_TAGS,
    ALLOWED_ATTR: ['href', 'target', 'rel'],
    ALLOWED_URI_REGEXP: URL_REGEXP,
  })
}

export function renderBio(text) {
  if (!text) return null

  const paragraphs = text.split(/\n{2,}/)
  return paragraphs.map((para, pi) => {
    if (para.startsWith('> ')) {
      return (
        <blockquote key={pi} className="bio-blockquote">
          {inlineFormat(para.slice(2))}
        </blockquote>
      )
    }
    const listLines = para.split('\n').filter(l => /^[-*]\s/.test(l))
    if (listLines.length > 0 && listLines.length === para.split('\n').filter(Boolean).length) {
      return (
        <ul key={pi} className="bio-list">
          {listLines.map((l, li) => <li key={li}>{inlineFormat(l.replace(/^[-*]\s/, ''))}</li>)}
        </ul>
      )
    }
    return <p key={pi} className="bio-para">{inlineFormat(para)}</p>
  })
}

function inlineFormat(text) {
  const tokens = []
  const pattern = /(\*\*(.+?)\*\*|\*(.+?)\*|\[(.+?)\]\((https?:\/\/[^\s)]+)\))/g
  let lastIndex = 0
  let match

  while ((match = pattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      tokens.push(text.slice(lastIndex, match.index))
    }
    if (match[2] !== undefined) tokens.push(<strong key={match.index}>{match[2]}</strong>)
    else if (match[3] !== undefined) tokens.push(<em key={match.index}>{match[3]}</em>)
    else if (match[4] !== undefined) tokens.push(
      <a key={match.index} href={match[5]} target="_blank" rel="noopener noreferrer" className="bio-link">
        {match[4]}
      </a>
    )
    lastIndex = pattern.lastIndex
  }
  if (lastIndex < text.length) tokens.push(text.slice(lastIndex))
  return tokens.length ? tokens : text
}
